import React from 'react';

import ErrorIcon from '@atlaskit/icon/core/status-error';
import { CheckboxOption, RadioOption, type OptionProps, type OptionType } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { StyledInvalidCheckboxOption } from '../../../../common/ui/picker/styled';

type CheckboxOptionProps = OptionProps<OptionType, true>;
type RadioOptionProps = OptionProps<OptionType, false>;

const renderOption = (props: OptionProps<OptionType, boolean>): React.JSX.Element =>
	props.isMulti ? (
		<CheckboxOption {...(props as CheckboxOptionProps)} />
	) : (
		<RadioOption {...(props as RadioOptionProps)} />
	);

export const Option = (props: OptionProps<OptionType, boolean>): React.JSX.Element => {
	if (props.data?.invalid) {
		return (
			<StyledInvalidCheckboxOption>
				{renderOption(props)}
				{/* @ts-ignore react-select unsupported props */}
				<Tooltip content={props.selectProps.fieldInvalidLabel}>
					<ErrorIcon label="Test" color={token('color.icon.danger')} />
				</Tooltip>
			</StyledInvalidCheckboxOption>
		);
	}

	return renderOption(props);
};
